import { QBooksLogo, XeroLogo } from '@approvalmax/ui';
import { Button } from '@approvalmax/ui/src/components';
import { errorHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { FC, memo, useMemo } from 'react';

import { messages } from './PullBudgetButton.messages';
import { PullBudgetButtonProps } from './PullBudgetButton.types';

const PullBudgetButton: FC<PullBudgetButtonProps> = memo((props) => {
    const { disabled, integrationType, isLoading, onClick } = props;
    const integrationName = selectors.integration.getIntegrationTypeName(integrationType);

    const logo = useMemo(() => {
        switch (integrationType) {
            case domain.IntegrationType.Xero:
                return <XeroLogo width={64} />;

            case domain.IntegrationType.QBooks:
                return <QBooksLogo width={64} />;

            default:
                throw errorHelpers.notImplementedError();
        }
    }, [integrationType]);

    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            color='blue80'
            block
            startIcon={logo}
            size='large'
            progress={isLoading}
            variant='outline'
        >
            {messages.pullFrom({ integrationName })}
        </Button>
    );
});

export default PullBudgetButton;
